module.exports = __webpack_public_path__ + "img/placeholder_video.eb14e442.jpg";